import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";
import "../styles/CadastroCliente.css";
import { cnpj } from "cpf-cnpj-validator";
import { Eye, EyeOff } from "lucide-react";


const CadastroCliente = () => {
   const navigate = useNavigate(); //
   
   const [formData, setFormData] = useState({
    razao_social: "",
    nome_fantasia: "",
    cnpj: "",
    modalidades: [],
    cep: "",
    endereco: "",
    numero: "",
    cidade: "",
    uf: "",
    telefone: "",
    website: ""
  });

  const [errors, setErrors] = useState({});
  const [sucesso, setSucesso] = useState(false);

  const aplicarMascara = (campo, valor) => {
    switch (campo) {
      case "cnpj":
        const cnpjNumeros = valor.replace(/\D/g, "").slice(0, 14);
        return cnpjNumeros
          .replace(/(\d{2})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1/$2")
          .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
      case "cep":
        return valor.replace(/\D/g, "").slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");
      case "telefone":
        const numeros = valor.replace(/\D/g, "").slice(0, 11);
        if (numeros.length <= 10) {
          return numeros
            .replace(/(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{4})(\d)/, "$1-$2");
        } else {
          return numeros
            .replace(/(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{5})(\d)/, "$1-$2");
        }
      default:
        return valor;
    }
  };

  const buscarCep = async (cepBruto) => {
    const cep = cepBruto.replace(/\D/g, "");
    if (cep.length !== 8) return;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) {
        setErrors((prev) => ({ ...prev, cep: "nao_encontrado" }));
        return;
      }
      
      setFormData((prevState) => ({
        ...prevState,
        endereco: data.logradouro || "",
        cidade: data.localidade || "",
        uf: data.uf || ""
      }));
      
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const mascarado = ["cnpj", "cep", "telefone"].includes(name)
      ? aplicarMascara(name, value)
      : value;

    setFormData((prevState) => {
      const atualizado = { ...prevState, [name]: mascarado };

      if (name === "cep" && mascarado.replace(/\D/g, "").length === 8) {
        buscarCep(mascarado);
      }

      return atualizado;
    });

    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevState) => {
      const updatedModalidades = checked
        ? [...prevState.modalidades, value]
        : prevState.modalidades.filter((mod) => mod !== value);
      return { ...prevState, modalidades: updatedModalidades };
    });
  };

  const validarCampo = (name, value) => {
    let erro = "";
  
    if (name === "cnpj") {
      const cnpjLimpo = value.replace(/\D/g, "");
      if (!cnpjLimpo || cnpjLimpo.length === 0) {
        erro = "obrigatorio";
      } else if (cnpjLimpo.length < 14) {
        erro = "incompleto";
      } else if (!cnpj.isValid(cnpjLimpo)) {
        erro = "invalido";
      }
    }
  
    if (name === "cep") {
      const cepLimpo = value.replace(/\D/g, "");
      if (!cepLimpo || cepLimpo.length === 0) {
        erro = "obrigatorio";
      } else if (cepLimpo.length !== 8) {
        erro = "invalido";
      }
    }
  
    setErrors((prev) => ({ ...prev, [name]: erro }));
  };
  

  
  const validarFormulario = () => {
    const novosErros = {};
    const camposObrigatorios = ["razao_social", "cnpj", "cep", "cidade", "uf", "endereco", "numero", "telefone"];

    camposObrigatorios.forEach((campo) => {
      if (!formData[campo] || formData[campo].trim() === "") {
        novosErros[campo] = "obrigatorio";
      }
    });

    // Validação de CNPJ com mensagem diferenciada
    const cnpjNumeros = formData.cnpj.replace(/\D/g, "");
    if (!formData.cnpj || cnpjNumeros.length < 14) {
     novosErros.cnpj = "obrigatorio";
    } else if (!cnpj.isValid(formData.cnpj)) {
      novosErros.cnpj = "invalido";
    }


    if (formData.modalidades.length === 0) {
      novosErros.modalidades = "obrigatorio";
    }

    setErrors(novosErros);
    return Object.keys(novosErros).length === 0;
  };


   const handleSubmit = async (e) => {
     e.preventDefault();

     if (!validarFormulario()) return;


     try {
       const response = await fetch("http://localhost:5000/api/clientes/", {
         method: "POST",
         headers: {
           "Content-Type": "application/json"
         },
         body: JSON.stringify(formData)
       });

       if (response.ok) {
         setSucesso(true);

         const data = await response.json();
         const clienteId = data.id;

         setTimeout(() => {
           setSucesso(false);
           if (clienteId) {
             navigate(`/cadastro-usuario/${clienteId}`);
           }
         }, 2000);
       } else if (response.status === 409) {
         alert("Já existe um cliente com esse CNPJ.");
       } else {
         console.error("Erro ao cadastrar cliente:", response.statusText);
         alert("Erro ao cadastrar cliente.");
       }
     } catch (error) {
       console.error("Erro de conexão:", error);
       alert("Erro de conexão com o servidor.");
     }
   };


   const renderErro = (campo) => {
    if (!errors[campo]) return null;
  
    if (campo === "cnpj") {
      if (errors.cnpj === "invalido") return <span className="campo-erro">CNPJ inválido</span>;
      if (errors.cnpj === "incompleto") return <span className="campo-erro">CNPJ incompleto</span>;
      if (errors.cnpj === "obrigatorio") return <span className="campo-erro">Obrigatório</span>;
    }
  
    if (campo === "cep") {
      if (errors.cep === "invalido") return <span className="campo-erro">CEP inválido</span>;
      if (errors.cep === "nao_encontrado") return <span className="campo-erro">CEP não encontrado</span>;
      if (errors.cep === "obrigatorio") return <span className="campo-erro">Obrigatório</span>;
    }
  
    return <span className="campo-erro">Obrigatório</span>;
  };
  

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Cadastro de Cliente</h2>
      <form onSubmit={handleSubmit}>

        {sucesso && <div className="sucesso-msg">Cliente cadastrado com sucesso!</div>}

        {/* Linha 1: CNPJ + Nome Fantasia */}
        <div className="form-row">
          <div className={`form-group ${errors.cnpj ? 'erro' : ''}`} style={{ width: '160px', flex: 'none' }}>
            <label>CNPJ</label>
            <input
              className="input-mask"
              type="text"
              name="cnpj"
              value={formData.cnpj}
              onChange={handleChange}
              onBlur={(e) => validarCampo(e.target.name, e.target.value)}
              placeholder="00.000.000/0000-00"
            />
            {renderErro("cnpj")}
          </div>
          <div className={`form-group ${errors.nome_fantasia ? 'erro' : ''}`}>
            <label>Nome Fantasia</label>
            <input type="text" name="nome_fantasia" value={formData.nome_fantasia} onChange={handleChange} placeholder="Digite o nome fantasia" />
            {renderErro("nome_fantasia")}
          </div>
        </div>

        {/* Linha 2: Razão Social */}
        <div className={`form-group form-group-full ${errors.razao_social ? 'erro' : ''}`}>
          <label>Razão Social</label>
          <input type="text" name="razao_social" value={formData.razao_social} onChange={handleChange} placeholder="Digite a razão social" />
          {renderErro("razao_social")}
        </div>

        {/* Modalidades */}
        <div className={`form-group section-title ${errors.modalidades ? 'erro' : ''}`}>
          <label>Modalidades</label>
          {renderErro("modalidades")}
        </div>
        <div className="checkbox-group">
          <label><input type="checkbox" value="Ensino Médio" onChange={handleCheckboxChange} /> Ensino Médio</label>
          <label><input type="checkbox" value="Preparatório" onChange={handleCheckboxChange} /> Preparatório</label>
          <label><input type="checkbox" value="Graduação" onChange={handleCheckboxChange} /> Graduação</label>
          <label><input type="checkbox" value="Pós-Graduação" onChange={handleCheckboxChange} /> Pós-Graduação</label>
          <label><input type="checkbox" value="Mestrado/Doutorado" onChange={handleCheckboxChange} /> Mestrado/Doutorado</label>
        </div>

        <hr className="form-divider" />

        {/* Endereço */}
        <div className="form-row cep-row">
          <div className={`form-group ${errors.cep ? 'erro' : ''}`} style={{ width: '110px', flex: 'none' }}>
            <label>CEP</label>
            <input
              className="input-mask"
              type="text"
              name="cep"
              value={formData.cep}
              onChange={handleChange}
              onBlur={(e) => validarCampo(e.target.name, e.target.value)}
              placeholder="00000-000"
            />
            {renderErro("cep")}
          </div>
          <div className={`form-group ${errors.cidade ? 'erro' : ''}`} style={{ flex: 1 }}>
            <label>Cidade</label>
            <input type="text" name="cidade" value={formData.cidade} onChange={handleChange} placeholder="Cidade" />
            {renderErro("cidade")}
          </div>
          <div className={`form-group ${errors.uf ? 'erro' : ''}`} style={{ width: '65px', flex: 'none' }}>
            <label>UF</label>
            <select name="uf" value={formData.uf} onChange={handleChange}>
              <option value="">UF</option>
              <option value="AC">AC</option>
              <option value="AL">AL</option>
              <option value="AP">AP</option>
              <option value="AM">AM</option>
              <option value="BA">BA</option>
              <option value="CE">CE</option>
              <option value="DF">DF</option>
              <option value="ES">ES</option>
              <option value="GO">GO</option>
              <option value="MA">MA</option>
              <option value="MT">MT</option>
              <option value="MS">MS</option>
              <option value="MG">MG</option>
              <option value="PA">PA</option>
              <option value="PB">PB</option>
              <option value="PR">PR</option>
              <option value="PE">PE</option>
              <option value="PI">PI</option>
              <option value="RJ">RJ</option>
              <option value="RN">RN</option>
              <option value="RS">RS</option>
              <option value="RO">RO</option>
              <option value="RR">RR</option>
              <option value="SC">SC</option>
              <option value="SP">SP</option>
              <option value="SE">SE</option>
              <option value="TO">TO</option>
            </select>
            {renderErro("uf")}
          </div>
        </div>

        <div className="form-row">
          <div className={`form-group ${errors.endereco ? 'erro' : ''}`} style={{ flex: 1 }}>
            <label>Endereço</label>
            <input type="text" name="endereco" value={formData.endereco} onChange={handleChange} placeholder="Rua, Avenida..." />
            {renderErro("endereco")}
          </div>
          <div className={`form-group ${errors.numero ? 'erro' : ''}`} style={{ width: '80px', flex: 'none' }}>
            <label>Número</label>
            <input type="text" name="numero" value={formData.numero} onChange={handleChange} placeholder="123" />
            {renderErro("numero")}
          </div>
        </div>

        {/* Contato */}
        <div className="form-row">
          <div className={`form-group ${errors.telefone ? 'erro' : ''}`} style={{ width: '160px', flex: 'none' }}>
            <label>Telefone</label>
            <input className="input-mask" type="text" name="telefone" value={formData.telefone} onChange={handleChange} placeholder="(00) 00000-0000" />
            {renderErro("telefone")}
          </div>
          <div className="form-group">
            <label>Website</label>
            <input type="text" name="website" value={formData.website} onChange={handleChange} placeholder="https://www.suaempresa.com.br" />
          </div>
        </div>

        {/* Ações */}
        <div className="form-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          <button type="button" className="btn btn-secondary"
           onClick={() => navigate("/clientes")}
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroCliente;
